module.exports = __webpack_public_path__ + "static/media/amy_wright.bbb553a3.png";